import { useEffect, useState } from "react"
import { Button, Card, Col, Dropdown, Jumbotron } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import { FaDownload } from "react-icons/fa"
import Get from "../../api/Get"
import { REPORTE_CITA_REASIGNADA } from "../../api/Routes"
import ComponentModalErrorSever from "../ComponentModalErrorSever"
import TableSearch from "../TableSearch"
import * as ExcelJS from "exceljs";
import { saveAs } from 'file-saver';

function ReporteNotificacionReasignacion({t, auth}){
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(false)

    //error
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    useEffect(()=>{
            let mounted = true
            setLoading(true)
            let url = `${REPORTE_CITA_REASIGNADA}/?notificationType=Reassigned`
            Get({url: url, access_token: auth.data.access_token})
            .then(response=>{
                //console.log(response)
                if(mounted){
                    if(response.data.data.response.length> 0){
                        let its = response.data.data.response.map(e=>({
                            id: e.created,
                            expediente: e.expedient,
                            subservicio: e.speciality.name,
                            medico_asignado: e.doctorAssigned.name,
                            medico_reasignado: e.doctorReassigned.name,
                            asigno: e.userCreated?.name
                        }))
                        setItems(its)
                    }else{
                        setItems([])
                    }
                }
                setLoading(false)
            })
            .catch(error=>{
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
                setItems([])
                setLoading(false)
            })
            return () => mounted = false;             
    }, [])

    const columns = [
        {
          dataField: "id",
          text: "ID",
          hidden: true,
        },
        {
            dataField: 'expediente',
            text: 'Expediente',
            headerStyle: { width: '10%' },
            editable: false  
        },
        {
            dataField: 'subservicio',
            text: 'Subservicio',
            headerStyle: { width: '20%' },
            editable: false  
        },
        {
            dataField: 'medico_asignado',
            text: 'Médico asignado',
            headerStyle: { width: '25%' },
            editable: false
        },
        {
            dataField: 'medico_reasignado',
            text: 'Médico reasignado',
            headerStyle: { width: '25%' },
            editable: false
        },
        {
            dataField: 'asigno',
            text: 'Creado',
            headerStyle: { width: '20%' },
            editable: false
        }
    ];

    const downloadExcel = () =>{        
        //console.log(items)
        //console.log('downloadexcel')

        var workbook = new ExcelJS.Workbook()
        workbook.creator = "Iké Asistencia";
        workbook.created = new Date();
        workbook.modified = new Date();
        workbook.lastPrinted = new Date();
        let sheet1 = workbook.addWorksheet("Datos");
        sheet1.views = [
            {state: 'frozen', xSplit: 0, ySplit: 1}
        ];

        //console.log(csvData)
        let arrDatos = items.map((item,i)=>[i+1,item.expediente, item.subservicio, item.medico_asignado, item.medico_reasignado, item.asigno])

        sheet1.addTable({
            name: 'DataTable',
            ref: 'A1',
            headerRow: true,
            totalsRow: false,
            style: {
                theme: 'TableStyleLight1'
            },
            columns: [
                {name: 'NO'},
                {name: 'Expediente'},
                {name: 'Subservicio'},
                {name: 'Médico asignado'},
                {name: 'Médico reasignado'},
                {name: 'Creado'}
              ],
            rows: arrDatos,
        }) 

        let firstRow = sheet1.getRow(1);
        firstRow.font = { name: 'New Times Roman', family: 4, size: 11, bold: false, color: {argb:'00000'} };
        firstRow.alignment = { vertical: 'middle', horizontal: 'center'};
        firstRow.height = 20;

        sheet1.getColumn(1).width = 8
        sheet1.getColumn(2).width = 15
        sheet1.getColumn(3).width = 25
        sheet1.getColumn(4).width = 35
        sheet1.getColumn(5).width = 45

        // save under export.xlsx
        workbook.xlsx.writeBuffer()
        .then(response=>{
            var blob = new Blob([response], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                saveAs(blob, `trazabilidad_citas_reasignadas.xlsx`);
        })
        .catch(error=>{
            console.log(error)
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }


    return (
        <>
            <Card className="shadow-1">
                <Card.Body>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="mr-5"><h6>Trazabilidad citas reasignadas</h6></div>
                        {items.length > 0 && <div>
                            <Button variant="outline-secondary" size="sm" onClick={downloadExcel}>
                                <FaDownload />
                            </Button>
                        </div>}
                    </div>
                
                <Dropdown.Divider />
                    {
                        loading && 
                        <Col xs="12" md="12">
                            <div className="text-center my-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </Col>
                    }
                    {
                        (items.length === 0 && !loading) &&
                        <Col xs="12" md="12">
                            <Jumbotron>
                                <div className="text-center">
                                    <p className="m-0">No existe información a mostrar</p>
                                </div>
                            </Jumbotron>
                        </Col>                                    
                    }
                    {
                        (items.length > 0 && !loading) &&     
                        <Col xs="12" md="12">
                            <TableSearch columns={columns} items={items} className="th-text-uppercase" placeholderSearch="" />
                        </Col>
                    }  
                </Card.Body>
            </Card>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </>
        
    )

}

export default withTranslation()(ReporteNotificacionReasignacion)